import React from "react";
import "./MainBanner.scss";
import ContactForm from "../../contact-form/ContactForm";
import hero from "../../../images/hero.mp4";

const MainBanner = () => {
  return (
    <section className="main_banner">
      {/* Background Video */}
      <video className="video-background" autoPlay loop muted playsInline>
        <source src={hero} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Overlay for content */}
      <div className="overlay">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-8">
              <div className="banner_content">
                <h5>The Largest</h5>
                <h1>co-working space in the heart of south delhi.</h1>
              </div>
            </div>
            <div className="col-md-4">
              <div className="banner_form">
                <ContactForm />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MainBanner;
